/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCashtagSuggestion} from '../api'

 export const useQueryGetCashtagSuggestion = createReactQueryHook('getCashtagSuggestion', getCashtagSuggestion)
